import { create } from 'zustand';

type EventStorageState = {
  finishAll: () => void;
  finishLoading: () => void;
  isLoading: boolean;
  // The duplicate-name verdict cannot live in RHF errors alone: handleSubmit re-runs the Zod
  // resolver, which drops manually set errors, so the step gate would lose it at the last step.
  isValuationNameTaken: boolean;
  loadingState: boolean[];
  setValuationNameTaken: (isValuationNameTaken: boolean) => void;
  startLoading: () => void;
};

export const eventStorage = create<EventStorageState>()((set) => ({
  isLoading: false,
  isValuationNameTaken: false,
  loadingState: [],
  setValuationNameTaken: (isValuationNameTaken) => set(() => ({ isValuationNameTaken })),
  startLoading: () =>
    set(({ loadingState }) => {
      const newLoadingState = [...loadingState, true];
      return {
        loadingState: newLoadingState,
        isLoading: newLoadingState.length > 0,
      };
    }),
  finishLoading: () =>
    set(({ loadingState }) => {
      const newLoadingState = loadingState.slice(0, -1);
      return {
        loadingState: newLoadingState,
        isLoading: newLoadingState.length > 0,
      };
    }),
  finishAll: () =>
    set(() => {
      return {
        loadingState: [],
        isLoading: false,
      };
    }),
}));
